import { render, staticRenderFns } from "./LabelStatus.vue?vue&type=template&id=78893a60"
import script from "./LabelStatus.vue?vue&type=script&lang=js"
export * from "./LabelStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports